export const downloadFile = (blob, fileName) => {
  const url = URL.createObjectURL(blob);

  const link = document.createElement("a");
  link.href = url;
  link.download = fileName;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};

/**
 * Removes the file extension from a filename.
 * It removes the last part of the string behind the last dot.
 * @param filename
 * @returns filename without extension
 */
export const removeExtension = (filename) => {
  if (!filename) {
    return filename;
  }

  const lastDotIndex = filename.lastIndexOf(".");
  return lastDotIndex === -1 ? filename : filename.substring(0, lastDotIndex);
};
